import type { FaireProductEntity } from "../../entity_types/product";

export const p_3vvvp6we5h: FaireProductEntity = {
  token: "p_3vvvp6we5h",
  type: "product",
  name: "Cozy Cable Knit Scarf - Holiday Gift",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/402e9beddbeed2de4672747bb61fbafe768f0e56297c8b7d09a170fe0627de6b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d09e53fbb0c1a929b00171f028520b2c21c2c1acdf91fd0bd43d39c4caf22ad3.png",
    "https://cdn.faire.com/fastly/b8762a8fabb504fd230a664b6d83333d865681151e3df64e713a0eb5de0ee0f8.png",
    "https://cdn.faire.com/fastly/300a798db54674937a42344e8012da94ef4f29170850c3ebb3aa869967ceafcf.png"
  ],
  priceDollars: 41,
  description: "Irresistibly soft comfort and a touch of cozy luxury to every cold-weather look. Designed to feel as good as it looks, it's the accessory you'Add a touch of cozy luxury to every holiday look with our Cable Knit Marshmallow Scarf. Crafted from signature Marshmallow fabric, it combines classic cable-knit texture with an ultra-plush, buttery-soft feel—making it the perfect winter accessory for holiday gifting, cold-weather layering, and everyday comfort.\n\nFabrication:\nMade from Softies' signature Cable Knit Marshmallow fabric, this scarf combines classic cable-knit texture with an ultra-plush handfeel. \n\nFeatures:\n● Classic scarf silhouette for versatile styling\n●  18\" x 76\"\n● Cable-knit texture adds dimension and timeless appeal\n● Lightweight yet cozy design provides comfortable warmth\n\nMaterials & Care:\n● 100% Polyester\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Layering during chilly weather\n● Travel and everyday wear\n● Thoughtful gifting throughout the season\n",
  tags: [],
  msrpDollars: 90,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:04.895Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
